import IndustryChallengesI18n from "@/components/landing/shared/IndustryChallengesI18n";
import { Clock, ShoppingCart, Users, TrendingDown } from "lucide-react";
const HerausforderungenEinzelhandelSection = () => <IndustryChallengesI18n translationPrefix="industryEinzelhandel" icons={[Clock, ShoppingCart, Users, TrendingDown]} />;
export default HerausforderungenEinzelhandelSection;
